var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      staticClass: "tooltip",
      attrs: { arrow: false },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function() {
            return [_c("span", [_vm._v(_vm._s(_vm.fullFileName))])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "attachments-wrapper",
          class: { error_class: _vm.isErrorFile },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.handleClick($event)
            }
          }
        },
        [
          _c("div", { staticClass: "attachments-wrapper__content" }, [
            _vm.isErrorFile
              ? _c(
                  "div",
                  { staticClass: "round-icon" },
                  [
                    _c("CompassIcon", {
                      attrs: {
                        type: "alert",
                        size: "extra-small",
                        icon: "close"
                      }
                    })
                  ],
                  1
                )
              : _c("svg", {
                  staticClass: "file-icon",
                  attrs: {
                    viewBox: _vm.fileType
                      ? _vm.fileType.viewBox
                      : _vm.defaultType && _vm.defaultType.viewBox
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.fileType
                        ? _vm.fileType.src
                        : _vm.defaultType && _vm.defaultType.src
                    )
                  }
                }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "attachments-wrapper__title typographies-paragraph-medium-semibold"
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.isErrorFile
                        ? _vm.attachment.error_text
                        : _vm.truncatedText
                    )
                  )
                ]),
                _vm._v(" "),
                !_vm.isErrorFile
                  ? _c("span", { staticClass: "light" }, [
                      _vm._v(
                        "\n                    (" +
                          _vm._s(_vm.sizeConverter(_vm.attachment.size)) +
                          ")\n                "
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.attachment.isFileLoaded
              ? _c("div", { staticClass: "progress-bar__wrapper" }, [
                  _c("div", { staticClass: "progress-bar" }, [
                    _c("div", { staticClass: "progress-bar__progress" })
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          !_vm.removeBtn
            ? _c("CompassIcon", {
                staticClass: "close_icon",
                attrs: {
                  type: _vm.isErrorFile ? "alert" : "primary",
                  size: "small",
                  icon: "close"
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("removeItem", _vm.attachment)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }